import React from 'react'
import doiResponse from '../constants/doiResponse'
import { parseWork } from '../services/workTransformer'
import Typography from 'material-ui/Typography'
import { withStyles } from 'material-ui/styles'

const styles = theme => ({
    preview: {
        marginTop: theme.spacing.unit
    }
})

const Preview = (props) => {
    const content = parseWork(doiResponse.message, props.options)
    return (
        <Typography className={props.classes.preview}
            variant="subheading">
            {content || ' '}
        </Typography>
    )
}

export default withStyles(styles)(Preview)


// WEBPACK FOOTER //
// ./src/components/preview.js